import {
  capMaxHeight,
  getPositionAndMaxHeightVertically,
} from '../dropdownHelpers';
import { ModalBackdrop } from './ModalBackdrop';
import { ModalBox } from './ModalBox';
import { ModalList } from './ModalList';
import { WithDropdown } from './WithDropdown';
import { CommonButtonWithDropdownProps, RenderButton } from './types';
import { OptionalPortal } from './OptionalPortal';

type ButtonWithDropdownTemplateProps = CommonButtonWithDropdownProps & {
  renderButton: RenderButton;
};

export const ButtonWithDropdownTemplate = ({
  options,
  footerContent,
  headerContent,
  isKeepOpen = false,
  alignMenuTo = 'left',
  dropdownStyle,
  iconStyle,
  disablePortal,
  dropdownSize,
  minDropdownSize,
  maxDropdownSize,
  maxDropdownHeight,
  onMenuOpen,
  onMenuClose,
  clickNamespace,
  requestOpen: onOpened,
  renderButton,
  isOpen: externallyManagedIsOpen,
  modalBoxVerticalOffset = 4,
}: ButtonWithDropdownTemplateProps) => {
  const forceAlignMenuToRight = alignMenuTo !== 'left';

  return (
    <WithDropdown
      onMenuOpen={onMenuOpen}
      onMenuClose={onMenuClose}
      requestOpen={onOpened}
    >
      {(openModal, closeModal, isOpen, getHostBox, hostRef) => {
        return (
          <>
            {renderButton(
              hostRef,
              externallyManagedIsOpen ?? isOpen,
              openModal
            )}
            {(externallyManagedIsOpen ?? isOpen) && (
              <OptionalPortal disablePortal={disablePortal}>
                <ModalBackdrop closeModal={closeModal} isKeepOpen={isKeepOpen}>
                  {(addKeyboardListener, removeKeyboardListener) => (
                    <ModalBox
                      footerContent={footerContent}
                      headerContent={headerContent}
                      clickNamespace={clickNamespace}
                      dropdownSize={dropdownSize}
                      minDropdownSize={minDropdownSize}
                      maxDropdownSize={maxDropdownSize}
                      getHostBox={getHostBox}
                      getPositionAndMaxHeight={(refBox, modalBox) =>
                        capMaxHeight(
                          getPositionAndMaxHeightVertically({
                            refBox,
                            modalBox,
                            isScrollable: true,
                            forceAlignToRight: forceAlignMenuToRight,
                            verticalOffset: modalBoxVerticalOffset,
                          }),
                          maxDropdownHeight
                        )
                      }
                    >
                      <ModalList
                        options={options}
                        addKeyboardListener={addKeyboardListener}
                        removeKeyboardListener={removeKeyboardListener}
                        iconStyle={iconStyle}
                        dropdownStyle={dropdownStyle}
                      />
                    </ModalBox>
                  )}
                </ModalBackdrop>
              </OptionalPortal>
            )}
          </>
        );
      }}
    </WithDropdown>
  );
};
